import type { BoxProps } from 'ink';
import { Box, Text } from 'ink';
import React, { useContext } from 'react';
import type { ReactNode } from 'react';
import { UnorderedListItemContext } from './UnorderedListItemContext.js';

type UnorderedListItemProps = {
  children: ReactNode;
  marker?: ReactNode;
} & BoxProps;

export function UnorderedListItem({
  children,
  marker: markerOverride,
  ...style
}: UnorderedListItemProps) {
  let { marker } = useContext(UnorderedListItemContext);
  if (markerOverride !== undefined) {
    marker = markerOverride;
  }

  return (
    <Box gap={1}>
      {marker && <Text>{marker}</Text>}
      <Box flexDirection="column" {...style}>
        {children}
      </Box>
    </Box>
  );
}
